import { combineReducers } from 'redux-immutable';
import { connectRouter } from 'connected-react-router';
import cartReducer from './views/cart/cart.reducer';
import premiumServicesReducer from './views/premium-services/premium-services.reducer';
import loginReducer from './views/login/login.reducer';
import userReducer from './views/user/user.reducer';
import shareReducer from './components/share/share.reducer';
import panDetailsReducer from './views/investor-profile/kyc-details/kyc-details.reducer';
import createLeadReducer from './components/create-lead/create-lead.reducer';
import personalDetailsReducers from './views/investor-profile/personal-details/personal-details.reducer';
import bankDetailsReducer from './views/investor-profile/bank-details/bank-details.reducer';
import occupationDetailsReducer  from './views/investor-profile/occupation-Details/occupation-details.reducer';
import profileViewReducer  from './views/investor-profile/profile.view.reducer';
import paymentmodeReducer from '../src/components/payment-mode/payment-mode.reducer';
import riskProfileViewReducer from 'views/investor-profile/risk-profile/risk-profile.reducer';
import paymentFlowReducer from 'views/payment-flow/payment-flow.reducer';
import flashReducer from 'components/flash/flash.reducer';
import userMandateReducer from 'views/mandates/mandate.reducer';
import nfoReducer from 'views/nfos/nfo.reducer';
import investmentCalculatorReducer from 'views/calculators/investment-calculators/investment-calculator.reducer';
import renderViewReducer from 'views/render-view/renderView.reducer';
import PendingOrderReducer from 'components/pending-order-popup/pendingOrder.reducer';

const reducers = {
	loginReducer,
	userReducer,
	cartReducer,
	premiumServicesReducer,
	shareReducer,
	createLeadReducer,
	personalDetailsReducers,
	bankDetailsReducer,
	occupationDetailsReducer,
	panDetailsReducer,
	profileViewReducer,
	paymentmodeReducer,
	riskProfileViewReducer,
	paymentFlowReducer,
	flashReducer,
	userMandateReducer,
	nfoReducer,
	investmentCalculatorReducer,
	renderViewReducer,
	PendingOrderReducer
};
export default function createRootReducer(asyncReducers = {}, browserHistory) {
	const rootReducer = combineReducers({
		...reducers,
		router: connectRouter(browserHistory),
		...asyncReducers
	});

	return rootReducer;
}
